<template>
	<app-page>
		<app-tabs app :tabs="tabs">
			<template v-slot:tab-item="{ tab }">
				<app-tab-item :tab="tab" value="areas">
					<app-heading :title="`${market.name} Areas`">
						<template v-slot:left>
							<app-button v-if="$ravello.can('marketmath.post')"
								class="d-none d-sm-inline-flex"
								color="success"
								small
								outlined
								:to="{ name: 'market-area', params: { area: 'new' } }"
							>Add Area</app-button>
						</template>
					</app-heading>
					<app-row>
						<app-cell>
							<app-data-table
								:items="areas"
								:headers="headers"
								:total="count"
								:refresh.sync="refresh"
								:initial-state="tableState"
								sort-by="name"
								@update="fetchAreas"
							>
								<template v-slot:actions="{ item }">
									<app-button
										v-if="$ravello.can('marketmath.put')"
										color="secondary"
										:to="{ name: 'market-area', params: { area: item._id } }"
										icon="fa-pencil-alt"
										table
									>
										Edit
									</app-button>
									<app-button-confirm
										v-if="$ravello.can('marketmath.delete')"
										color="error"
										icon="fa-trash"
										table
										label-confirm="Remove"
										:description="`Are you sure you want to remove area`
											+ ` <b>${item.name}</b>?`"
										title="Remove Area"
										@click="onDelete(item._id)"
									>
										Remove
									</app-button-confirm>
								</template>
							</app-data-table>
						</app-cell>
					</app-row>
					<app-floating-button
						class="d-inline-flex d-sm-none"
						:to="{ name: 'market-area', params: { area: 'new' } }"
						color="success"
						icon="fa-plus"
					/>
				</app-tab-item>
			</template>
		</app-tabs>
	</app-page>
</template>

<script>
import { filters, search, tableState } from '@/mixins'
import { marketMathTabs } from '@/datasources/tabs'

export default {
	mixins: [filters, search, tableState],
	data() {
		return {
			market: {
				name: '',
			},
			areas: [],
			count: -1,
			refresh: false,
			tabs: [],
			headers: [{
				text: 'Name',
				value: 'name',
				sortable: true,
			}, {
				text: 'Slug',
				value: 'slug',
				sortable: true,
			}, {
				text: 'City',
				value: 'market_city.name',
				sortable: false,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
			defaultTableSort: 'name',
		}
	},
	computed: {
		marketId() {
			return this.$route.params.market
		},
	},
	async mounted() {
		this.market = await this.$ravello.graphql('market', this.marketId)
			.fields(['name'])
			.query()

		this.tabs = marketMathTabs(this.marketId)
	},
	methods: {
		async fetchAreas(pagination) {
			this.updateTableState(pagination)

			const request = this.$ravello.graphql('areas')
				.parent(this.$ravello.graphql('market', this.marketId))
				.fields(['_id', 'name', 'slug'])
				.include(this.$ravello.graphql('market_city').field('name'))
				.fromPagination(pagination)

			if (this.count === -1) {
				request.count('count')
			}
			try {
				this.areas = await request.query()
				if (this.count === -1) {
					this.count = request.results.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},

		async onDelete(id) {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request()
					.v(2)
					.to('markets')
					.to(this.marketId)
					.to('areas')
					.to(id)
					.delete()
				this.refresh = true
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
		},
	},
}
</script>
